import { API_BASE_URL } from '../config/api';

/** Payment API host without `/api` suffix (e.g. https://bookapt-payment-api.onrender.com). */
export function getPaymentApiRoot(): string {
  return API_BASE_URL.endsWith('/api') ? API_BASE_URL.slice(0, -4) : API_BASE_URL;
}

export async function buildFrontDeskLinks(businessId: string, businessName: string) {
  const apiRoot = getPaymentApiRoot();
  const encodedBusinessId = encodeURIComponent(businessId);
  const encodedBusinessName = encodeURIComponent(businessName || 'Your Business');
  const signUrl = `${apiRoot}/api/business/${encodedBusinessId}/front-desk-sign.pdf?businessName=${encodedBusinessName}`;

  // Prefer the short /b/:code link (see /api/business/:businessId/short-link) —
  // it's what a business owner actually copies into emails/texts, and much
  // shorter than the raw Firestore ID. Falls back to the long-ID link (still
  // fully functional) if the request fails, e.g. offline.
  try {
    const res = await fetch(`${apiRoot}/api/business/${encodedBusinessId}/short-link`);
    const data = await res.json();
    if (data?.success && data?.bookingUrl) {
      return { bookingUrl: data.bookingUrl as string, signUrl };
    }
  } catch {
    // fall through to the long-form link below
  }

  return {
    bookingUrl: `${apiRoot}/b/${encodedBusinessId}`,
    signUrl,
  };
}
